import { HistoryStatus } from "./enums/historyStatus";
import { HistoryType } from "./enums/historyType";


export const listData = [
    {
        id: 1,
        type: HistoryType.QUOTATION,
        title: 'Petición de cotización',
        dateInit: '02/10/2024',
        provider: 'Juan Andrés Granados Barrios',
        status: HistoryStatus.UNATTENDED
    },
    {
        id: 2,
        type: HistoryType.QUOTATION,
        title: 'Petición de cotización',
        dateInit: '02/10/2024',
        provider: 'Juan Andrés Granados Barrios',
        description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Dolor necessitatibus sit similique, quaerat odio accusantium animi deleniti magnam voluptatem non hic laborum voluptatibus ducimus commodi, deserunt numquam! Iste, aperiam? Quae.',
        status: HistoryStatus.SENT
    },
    {
        id: 3,
        type: HistoryType.QUOTATION,
        title: 'Petición de cotización',
        dateInit: '02/10/2024',
        dateFinish: '03/12/2024',
        provider: 'Juan Andrés Granados Barrios',
        description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Dolor necessitatibus sit similique, quaerat odio accusantium animi deleniti magnam voluptatem non hic laborum voluptatibus ducimus commodi, deserunt numquam! Iste, aperiam? Quae.',
        status: HistoryStatus.REJECTED
    },
    {
        id: 4,
        type: HistoryType.QUOTATION,
        title: 'Petición de cotización',
        dateInit: '02/10/2024',
        dateFinish: '03/12/2024',
        provider: 'Juan Andrés Granados Barrios',
        description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Dolor necessitatibus sit similique, quaerat odio accusantium animi deleniti magnam voluptatem non hic laborum voluptatibus ducimus commodi, deserunt numquam! Iste, aperiam? Quae.',
        status: HistoryStatus.APPROVED
    },
    {
        id: 5,
        type: HistoryType.SOLUTION,
        title: 'Petición de solución',
        dateInit: '03/12/2024',
        provider: 'Juan Andrés Granados Barrios',
        status: HistoryStatus.UNATTENDED
    },
    {
        id: 6,
        type: HistoryType.SOLUTION,
        title: 'Petición de solución',
        dateInit: '03/12/2024',
        provider: 'Juan Andrés Granados Barrios',
        description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Dolor necessitatibus sit similique, quaerat odio accusantium animi deleniti magnam voluptatem non hic laborum voluptatibus ducimus commodi, deserunt numquam! Iste, aperiam? Quae.',
        status: HistoryStatus.SENT
    },
    {
        id: 7,
        type: HistoryType.SOLUTION,
        title: 'Petición de cotización',
        dateInit: '02/10/2024',
        dateFinish: '03/12/2024',
        provider: 'Juan Andrés Granados Barrios',
        description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Dolor necessitatibus sit similique, quaerat odio accusantium animi deleniti magnam voluptatem non hic laborum voluptatibus ducimus commodi, deserunt numquam! Iste, aperiam? Quae.',
        status: HistoryStatus.REJECTED
    },
    {
        id: 8,
        type: HistoryType.SOLUTION,
        title: 'Petición de cotización',
        dateInit: '02/10/2024',
        dateFinish: '03/12/2024',
        provider: 'Juan Andrés Granados Barrios',
        description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Dolor necessitatibus sit similique, quaerat odio accusantium animi deleniti magnam voluptatem non hic laborum voluptatibus ducimus commodi, deserunt numquam! Iste, aperiam? Quae.',
        status: HistoryStatus.APPROVED
    }
]